import { HttpRequestError }                       from '../../models';
import { handleHttpError, HttpErrorHandler }      from './HttpErrorHandler';

/**
 * Await to the asynchronous execution of an HTTP request.
 *
 * @param { Promise } promise Http request Promise.
 *
 * @return { Promise } Promise of the asynchronous treatment.
 */
export function toHttpRequest<T, U>(promise: Promise<T>): Promise<[ HttpRequestError | undefined, T | undefined]> {

    return promise.then<[HttpRequestError | undefined, any]>((response: any) => {
                      if (Array.isArray(response.data)) {
                        return response.data.reduce((acc: any, item: any) => {
                            const {exceptions, ...results} = item;

                            const error: HttpRequestError | undefined = exceptions.errcode > 0 ? HttpErrorHandler.handleServerError(exceptions) : undefined;

                            return [ error ? [...acc[0], error] : undefined, results ? [...acc[1], results] : undefined];
                          }, [ [], [] ],
                        );
                      } else {
                        const { exceptions, ...results } = response.data;
                        let err: HttpRequestError | undefined;
                        if (exceptions.errcode > 0) {
                          err = HttpErrorHandler.handleServerError(exceptions);
                        }
                        return [err, results];
                      }
                  })
                  .catch<[any, undefined]>((err: any) => {
                      if (!err.response) { // Axios errors (Timeout for instance)
                        return [handleHttpError(err, err.message), undefined];
                      }
                      // delegates error management to HttpErrorHandler
                      return [handleHttpError(err.response, err.message), undefined];
                  });
  }
export default toHttpRequest;
